'use client'

import React from 'react'
import { Navigation } from 'swiper'
import { Swiper, SwiperSlide } from 'swiper/react'
import PropTypes from 'prop-types'
import { BlogCard } from '../individual-components/blog-card'

const PublicationScroll = ({ posts }) => {
    return (
        <div className="relative mx-8 sm:mx-2 md:block hidden  mb-8">
            <Swiper
                modules={[Navigation]}
                slidesPerView={1}
                navigation={{
                    nextEl: '.next',
                    prevEl: '.prev',
                }}
                loop
            >
                {posts.map((post) => (
                    <SwiperSlide key={post?.title} className='py-10 sm:px-2'>
                        <BlogCard blogData={post} />
                    </SwiperSlide>
                ))}
            </Swiper>
            <div className="relative z-10 flex gap-4 lg:gap-8 select-none w-full max-w-md mx-auto px-4 xs:px-0">
                <div role='button' className="outline-none cursor-pointer prev rounded-full border p-4 lg:p-5 hover:bg-gray-200 group transition-all duration-200 bg-white" aria-label="Previous slide">
                    <svg className="group-hover:scale-125 transition-all duration-200" width="14" height="14" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M17 7.99996C17 8.26517 16.8946 8.51953 16.7071 8.70706C16.5196 8.8946 16.2652 8.99996 16 8.99996L4.414 8.99996L8.708 13.292C8.89577 13.4797 9.00126 13.7344 9.00126 14C9.00126 14.2655 8.89577 14.5202 8.708 14.708C8.52023 14.8957 8.26555 15.0012 8 15.0012C7.73445 15.0012 7.47977 14.8957 7.292 14.708L1.292 8.70796C1.19887 8.61507 1.12499 8.50471 1.07458 8.38322C1.02416 8.26173 0.998213 8.13149 0.998213 7.99996C0.998213 7.86842 1.02416 7.73818 1.07458 7.61669C1.12499 7.4952 1.19887 7.38485 1.292 7.29196L7.292 1.29196C7.47977 1.10418 7.73445 0.998696 8 0.998696C8.26555 0.998696 8.52023 1.10418 8.708 1.29196C8.89578 1.47973 9.00126 1.73441 9.00126 1.99996C9.00126 2.26551 8.89577 2.52018 8.708 2.70796L4.414 6.99996L16 6.99996C16.2652 6.99996 16.5196 7.10531 16.7071 7.29285C16.8946 7.48039 17 7.73474 17 7.99996Z" fill="#EB532E"></path>
                    </svg>
                </div>
                <div role='button' className="outline-none cursor-pointer next rounded-full border p-4 lg:p-5 hover:bg-gray-200 group transition-all duration-200 bg-white" aria-label="Next slide">
                    <svg className="group-hover:scale-125 transition-all duration-200" width="14" height="14" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fillRule="evenodd" clipRule="evenodd" d="M-6.1207e-07 7.99996C-5.88884e-07 8.26517 0.105356 8.51953 0.292893 8.70706C0.480429 8.8946 0.734783 8.99996 0.999999 8.99996L12.586 8.99996L8.292 13.292C8.10423 13.4797 7.99874 13.7344 7.99874 14C7.99874 14.2655 8.10423 14.5202 8.292 14.708C8.47977 14.8957 8.73445 15.0012 9 15.0012C9.26555 15.0012 9.52023 14.8957 9.708 14.708L15.708 8.70796C15.8011 8.61507 15.875 8.50471 15.9254 8.38322C15.9758 8.26173 16.0018 8.13149 16.0018 7.99996C16.0018 7.86842 15.9758 7.73818 15.9254 7.61669C15.875 7.4952 15.8011 7.38485 15.708 7.29196L9.708 1.29196C9.52023 1.10418 9.26555 0.998696 9 0.998696C8.73445 0.998696 8.47977 1.10418 8.292 1.29196C8.10422 1.47973 7.99874 1.73441 7.99874 1.99996C7.99874 2.26551 8.10423 2.52018 8.292 2.70796L12.586 6.99996L0.999999 6.99996C0.734783 6.99996 0.480429 7.10531 0.292893 7.29285C0.105356 7.48039 -6.35256e-07 7.73474 -6.1207e-07 7.99996Z" fill="#EB532E"></path>
                    </svg>
                </div>
            </div>
        </div>
    )
}

PublicationScroll.propTypes = {
    posts: PropTypes.array
}

export default PublicationScroll